import { Image } from "./image";
import React, { useContext, useState } from "react";
import { LanguageContext } from "../context/LanguageContext";
import en from "../data/data.json";
import cs from "../data/data_cs.json";
import { Lightbox } from "./lightbox";

export const Gallery = (props) => {
  const { language } = useContext(LanguageContext);
  const translations = language === "cs" ? cs : en;

  const items = props.data || [];
  const [openIndex, setOpenIndex] = useState(-1);

  const openAt = (i) => {
    setOpenIndex(i);
  };
  const close = () => setOpenIndex(-1);

  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>{translations.GalleryTitle}</h2>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {items.length
              ? items.map((d, i) => (
                  <div key={`${d.title}-${i}`} className="col-sm-6 col-md-4 col-lg-4">
                    <Image
                      title={d.title}
                      largeImage={d.largeImage}
                      smallImage={d.smallImage}
                      onClick={() => openAt(i)}
                    />
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
      </div>

      {openIndex >= 0 && (
        <Lightbox
          items={items}
          startIndex={openIndex}
          onClose={close}
        />
      )}
    </div>
  );
};
